export const getUserInfo = (msalInstance) => {
    if (process.env.REACT_APP_AUTH_ENABLED === 'false' || !msalInstance) {
        return ''
    }

    const accounts = msalInstance.getAllAccounts();
    return {
        name: accounts[0]?.name || '',
        //email: accounts[0]?.username || '',
        //id: accounts[0]?.localAccountId || ''
    };
};